import { useMemo } from "react";
import { currentUserDataOrFalseQuery } from "@/services/reports/useUserData";
import { useTCEConnectionCheck } from "@/components/TCEConnectionHealth";
import { createReportQuery } from "@/services/reports/useReport";
import ReportLoading from "../edit/ReportLoading";
import { ValidationScoreBoardContext } from "@/services/validation/context";
import ValidationScoreBoard from "@/services/validation/ValidationScoreBoard";
import BlockListMananger from "./BlockListManager";
import useCurrentReportId from "@/hooks/useCurrentReportId";
import UnknownError from "@/components/error-displays/UnknownError/UnknownError";
import {
  DEFAULT_FHIR_ENDPOINT,
  FHIREndpoint,
  FHIREndpointContext,
} from "@/hooks/useFHIREndpoint";
import { MultiFormRefProvider } from "@/components/MultiFormSubmit/MultiFormRefContext";
import { useQuery } from "react-query";
import useCompositionSync from "@/hooks/smart-web-messaging/useCompositionSync";
import useLaunchedFrom from "@/hooks/useLaunchedFrom";

function MinimalReportViewer() {
  const isSynops = useLaunchedFrom("Synops");
  const reportId = useCurrentReportId();

  const { data: user, isLoading: loadingUser } = useQuery(
    currentUserDataOrFalseQuery,
  );

  const { data: report, isLoading: loadingReport } = useQuery({
    ...createReportQuery(reportId),
    staleTime: 1000 * 60, // 1 minute
  });

  const vsb = useMemo(() => new ValidationScoreBoard(), []);

  useCompositionSync(reportId, { enabled: isSynops });
  useTCEConnectionCheck();

  if (loadingUser || loadingReport) {
    return <ReportLoading />;
  }

  if (!user) {
    return <UnknownError title="We kunnen je gebruikersgegevens te laden." />;
  }

  if (!report) {
    return <UnknownError title="We hebben je verslag niet gevonden." />;
  }

  const endpointSerialized = sessionStorage.getItem("fhirEndpoint");
  const endpoint: FHIREndpoint = endpointSerialized
    ? JSON.parse(endpointSerialized)
    : DEFAULT_FHIR_ENDPOINT;

  return (
    <FHIREndpointContext.Provider value={endpoint}>
      <ValidationScoreBoardContext.Provider value={vsb}>
        <div className="ph-no-capture bg-gray-ultralight">
          <div className="mx-auto h-full w-full min-w-[30%] overflow-y-scroll bg-gray-ultralight px-4 pt-6">
            <MultiFormRefProvider>
              <BlockListMananger readOnly reportId={reportId} />
            </MultiFormRefProvider>
          </div>
        </div>
      </ValidationScoreBoardContext.Provider>
    </FHIREndpointContext.Provider>
  );
}

export default MinimalReportViewer;
